import { useState } from 'react';
import Grid from '@mui/material/Grid';
import Layout from '../../componentsv2/Layout';
import Typography from '../../componentsv2/Typography';
import Button from '../../componentsv2/Button';
import { AddIcon } from '../../components/Icons';
import CreateCompanyModal from './admin/CreateCompanyModal';
import { Tabs, Tab } from '../../componentsv2/Tabs';
import { useAppSelector } from '../../store';
import { useLazyTranslation } from '../../hooks/i18n';
import AdminDashboardSkeleton from './admin/skeleton';
import AllCompanies from './admin/AllCompanies';
import InvoiceFinancingCompanies from './admin/InvoiceFinancingCompanies';

enum TabValues {
  All = 0,
  InvoiceFinancing,
}

const AdminDashboard = () => {
  const { t, isLoading: isLoadingTranslations } = useLazyTranslation(['admin']);
  const user = useAppSelector((state) => state.auth.user);
  const [showCreateCompanyModal, setShowCreateCompanyModal] = useState(false);
  const [tab, setTab] = useState(TabValues.All);

  if (isLoadingTranslations) {
    return <AdminDashboardSkeleton />;
  }

  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" fontWeight="700">
            {`${t('common:welcome')}, ${user?.firstName}`}
          </Typography>
          <Button onClick={() => setShowCreateCompanyModal(true)} startIcon={<AddIcon />}>
            {t('admin:dashboard.createCompany')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Tabs
            value={tab}
            onChange={(_, newValue) => {
              setTab(newValue);
            }}
          >
            <Tab value={0} label={t('admin:dashboard.allCompanies')} />
            <Tab value={1} label={t('admin:dashboard.invoiceFinancingCompanies')} />
          </Tabs>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', flex: 1 }}>
          {tab === TabValues.All && <AllCompanies t={t} />}
          {tab === TabValues.InvoiceFinancing && <InvoiceFinancingCompanies t={t} />}
        </Grid>
      </Grid>
      <CreateCompanyModal
        isOpen={showCreateCompanyModal}
        handleClose={() => setShowCreateCompanyModal(false)}
        t={t}
      />
    </Layout>
  );
};

export default AdminDashboard;
